// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
};

savedOrderDetailsActionButtonsStyles.buttonsHiddenContainer = {
    ...mergeWithCss(savedOrderDetailsActionButtonsStyles.buttonsHiddenContainer, {
        css: css`
            display: flex;
        `,
    }),
};

savedOrderDetailsActionButtonsStyles.middleHiddenContainer = {
    ...mergeWithCss(savedOrderDetailsActionButtonsStyles.middleHiddenContainer, {
        css: css`
            display: flex;
        `,
    }),
};

savedOrderDetailsActionButtonsStyles.twoButtonModalStyles = {
    submitButton: {
        color: "primary",
    },
    buttonsGridItem: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
};
